<template>
  <v-dialog :value="value" width="800" persistent>
    <v-card>

      <v-card-title class="mb-4">{{ getCurrentProduct.id }} - Edit Provisioning Info</v-card-title>

      <v-card-text>
        <v-textarea label="Provisioning Info" placeholder="Type here..." v-model="quick_note" counter="250" :rules="noteRules" outlined row-height="2" auto-grow></v-textarea>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions>
        <v-spacer></v-spacer>

        <v-btn color="primary" small :loading="getUpdateProvisioningInfoLoading" :disabled="disableSave" @click="save">Save</v-btn>
        <v-btn color="primary" small outlined :disabled="getUpdateProvisioningInfoLoading" @click="close" class="ml-3">Close</v-btn>
      </v-card-actions>

    </v-card>
  </v-dialog>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex';

  export default {
    props: {
      value: {
        type: Boolean,
        default: false
      }
    },

    data() {
      return {
        quick_note: '',
        noteRules: [val => val.length <= 250 || 'Max 250 characters'],
      }
    },

    computed: {
      ...mapGetters('products',['getCurrentProduct']),
      ...mapGetters('telcoWorkflow', ['getUpdateProvisioningInfoLoading', 'getUpdateProvisioningInfoError']),

      disableSave() {
        return this.getUpdateProvisioningInfoLoading || this.quick_note.length > 250;
      }
    },

    watch: {
      value(val) {
        if (val && this.getCurrentProduct.quick_note) {
          this.quick_note = this.getCurrentProduct.quick_note;
        }
      }
    },
    
    methods: {
      ...mapActions('telcoWorkflow', ['updateProvisioningInfo']),

      async save() {
        await this.updateProvisioningInfo({product_id: this.getCurrentProduct.id, data: {quick_note: this.quick_note}}); 

        if (!this.getUpdateProvisioningInfoError) {
          this.close();
          setTimeout(()=>{
            window.location.reload();
          }, 500);  
        }
      },

      close() {
        this.quick_note = '';
        this.$emit('input', false);
      }
    }
  }
</script>

<style lang="scss" scoped>
</style>